import { store, getElement } from "@wordpress/interactivity"
import { animate, stagger, scroll, inView, easeOut } from "motion"
import "./style.scss"


const { actions } = store("bk-transitions", {
    actions: {
        initInViewElements: () => {
            const inViewElements = document.querySelectorAll(".transition-in-view")
            if (!inViewElements) return
            inViewElements.forEach(e => {
                inView(e, () => {
                    e.classList.add("visible")
                })
            })
        },

        staggerPortfolio: () => {
            const staggerElements = document.querySelectorAll(".stagger-visible")
            if (!staggerElements) return

            staggerElements.forEach(e => {
                inView(e, () => {
                    e.classList.add("visible")
                })
            })

            staggerElements.forEach(e => {
                inView(e, () => {
                    animate(e, { opacity: [0, 1] }, { duration: 0.5, delay: 0.2, ease: easeOut })
                })
            })
        },

        introColText: () => {
            const { ref } = getElement()
            if (!ref) return

            inView(ref, () => {
                animate(".transition-col-child", { opacity: [0, 1] }, { duration: 0.3, delay: stagger(0.2), ease: easeOut })
            })
        },
    },
})

actions.initInViewElements()